import type { Ref } from 'vue'

export async function loginApi(api: () => Promise<void>, loading?: Ref<boolean>, _simulation?: boolean) {
  try {
    if (loading)
      loading.value = true
    await api()
  }
  catch (e) {
    if (loading)
      loading.value = false
    throw e
  }
}
